let Api = {
    "PROTAL_N_INDUSTRYFRIENDLY_FINDLIST": "/portal-api/n/IndustryFriendlyLinkManage/findList", //友情链接
    "PROTAL_N_INDUSTRYMODULE_FINDPAGELIST": "/portal-api/n/IndustryModuleMage/findPageList", // 关于我们
    "PROTAL_N_PROTOCOL_GETPROTOCOLINFO": "/portal-api/n/protocol/getProtocolInfo", // 协议配置
    "PROTAL_N_INDUSTRYCERTIFICATION_FINDLIST_TYPE": "/portal-api/n/IndustryCertification/findList", // 商务资质/公司主体
    "PROTAL_N_INDUSTRYMANGE_FINDDEFAULTBYTYPE": "/portal-api/n/IndustryMange/findDefaultByType", // 基础信息
    
    "SECURITY_W_LOGOUT": "/system/w/logout",//登出

    
    "INDUSTRYMODULEMAGE_FINDPAGELIST": "/portal-api/n/IndustryModuleMage/findPageList", //内容管理和关于我们模块分页查询列表
    "INDUSTRYCOLUMNMANAGE_FINDPAGELIST": "/portal-api/n/IndustryColumnManage/findList", //内容管理和关于我们模块分页查询列表
    "INDUSTRYMODULEMAGE_FINDINFO": "/portal-api/n/IndustryModuleMage/findInfo", //内容管理和关于我们模块分页查询列表
    "INDUSTRYLMODULECONTENT_FINDLIST": "/portal-api/n/IndustrylModuleContent/findList", //内容管理和关于我们模块 内容查询列表

    "SIMPLE_N_QPSTZX_INDEX_WDZXPZLIST": "/simple-api/n/qpstzx/index/wdzxpzList", // 商通中心五大核心业务
    "SIMPLE_N_QPSTZX_INDEX_HXJZLLIST": "/simple-api/n/qpstzx/index/hxjzlList", // 首页核心竞争力查询


    "W_PERSON_GET": "/b2b/w/person/get", //获取个人信息
    "TRADE_W_STAT_STATISTICS": '/trade/w/stat/statistics', //数字店铺平台首页统计
    "B2B_W_STAT_STATISTICS": '/b2b/w/stat/statistics', //数字供销平台首页统计
    "B2B_W_BUYERORDER_BUYERSTATISTICS": "/b2b/w/buyerOrder/buyerStatistics", //数字供销平台 会员采购排行 Top10
    "SYSTEM_W_ENTP_FINDOPENSERVE": "/system/w/EntpService/findPageList", //获取服务菜单
    "ORDER_STATECOUNT": "/b2b/w/buyerOrder/stateCount",//查询我的页面订单状态数量
    "MEMB_GETINFO": "/system/w/memb/getMembInfo",//认证状态
    "PLATCONFIG_FINDALLPLATCONFIG": "/system/n/findAllPlatConfig", //平台配置信息
	"SYSTEM_N_FINDALLPLATCONFIG": "/system/n/findAllPlatConfig", //

    "SYSTEM_W_ENTP_FINDOPENSERVEAUT": "/system/w/entp/findEntpOpenServices", //获取服务菜单
    "ENTPAUTH_GETDETAIL": "/system/w/merchantAuth/getDetail", //查询认证信息
    "B2B_N_PLAT_FINDDEFAULT": "/system/w/PlatInfoMage/findInfo", //查询平台基本信息

    "ADDRESS_AREA_FINDAREATREE": "/b2b/n/address/area/findAreaTree", //查询行政区划树
    
}
module.exports = Api